///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

import messages from "../../../helpers/messages";
import ChevronRight from "../../icons/ChevronRight";
import { updateStep } from "../../../slices/bidProcurementSlice";
import { handleCarrierMatchingValidations } from "../../../helpers/handleCarrierMatchingValidations";
import Spinner from "../../icons/Spinner";

const CarrierMatchingActions = ({
  openUnsavedModal,
  areLaneMatchesChanged,
  handleFinish
}) => {
  const dispatch = useDispatch();
  const {
    capacityMatchCarriers: { carriers, laneMatches, noneOption },
    rowsSelected,
    saveCarrierMatchDetails,
    step
  } = useSelector(state => state.bidProcurement);

  const allValid = handleCarrierMatchingValidations(
    step,
    rowsSelected?.length > 1,
    laneMatches
  );

  const disableContinueButton =
    (step === 1 && !carriers?.some(x => x.checked === true)) ||
    (step === 2 && !allValid);

  return (
    <div className="action-steps">
      {step === 2 && (
        <button
          className="text-button font-size-14 mx-8 ml-32 h-32 cursor-pointer text-transform-none border-cobalt-blue"
          data-testid="view-matches"
          style={{ minWidth: "150px" }}
          onClick={() => dispatch(updateStep(step - 1))}
        >
          <ChevronRight
            className="align-text-bottom mr-8"
            style={{ transform: `rotate(180deg)` }}
          />
          <FormattedMessage
            {...messages.viewMatches}
            values={{ matches: carriers?.length }}
          />
        </button>
      )}

      {step === 3 && (
        <button
          className="text-button font-size-14 mx-8 ml-32 h-32 cursor-pointer text-transform-none border-cobalt-blue"
          data-testid="match-details"
          style={{ minWidth: "150px" }}
          onClick={() => dispatch(updateStep(step - 1))}
        >
          <ChevronRight
            className="align-text-bottom mr-8"
            style={{ transform: `rotate(180deg)` }}
          />
          {messages.matchDetails.defaultMessage}
        </button>
      )}

      <div className="fr">
        <button
          className="text-button font-size-14 mx-8 ml-32 h-32 cursor-pointer text-transform-none"
          data-testid="cancel"
          style={{ minWidth: "91px" }}
          onClick={openUnsavedModal}
        >
          {messages.cancel.defaultMessage}
        </button>

        {((step === 1 && !noneOption) ||
          (step === 2 && rowsSelected?.length > 1)) && (
          <button
            className="text-button font-size-14 mx-8 mr-32 h-32 bg-cobalt-blue text-white blue-button cursor-pointer text-transform-none"
            data-testid="continue"
            style={{ minWidth: "91px" }}
            onClick={() => dispatch(updateStep(step + 1))}
            disabled={disableContinueButton}
          >
            {messages.continue.defaultMessage}
          </button>
        )}

        {((step === 1 && noneOption) ||
          (step === 2 && rowsSelected?.length === 1) ||
          step === 3) &&
          (saveCarrierMatchDetails.isFetching ? (
            <button
              className="text-button font-size-14 mx-8 mr-32 h-32 bg-cobalt-blue text-white blue-button cursor-pointer text-transform-none"
              data-testid="spinner"
              style={{ minWidth: "91px" }}
            >
              <Spinner
                fill="#FFF"
                height="16px"
                width="16px"
                className="spinner mt-4"
              />
            </button>
          ) : (
            <button
              className="text-button font-size-14 mx-8 mr-32 h-32 bg-cobalt-blue text-white blue-button cursor-pointer text-transform-none"
              data-testid="finish"
              style={{ minWidth: "91px" }}
              disabled={!allValid || !areLaneMatchesChanged}
              onClick={handleFinish}
            >
              {messages.finish.defaultMessage}
            </button>
          ))}
      </div>
    </div>
  );
};

export default CarrierMatchingActions;
